<template>
  <div class="content">
    <!-- 布局 -->
    <div class="layout">
      <!-- 文本域左 -->
      <div class="left-can">
        <el-input
          type="textarea"
          v-model="leftInput"
          placeholder="请输入内容"
          maxlength="1000"
          show-word-limit
        ></el-input>
      </div>
      <!-- 按钮 -->
      <div class="changeBtn">
        <el-button @click="changeClick" type="primary"
          >转化<i class="el-icon-right"></i
        ></el-button>
      </div>
      <!-- 文本域右 -->
      <div class="right-can">
        <el-input
          type="textarea"
          v-model="rightInput"
          placeholder="内容转化为"
          maxlength="1000"
          show-word-limit
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { change } from "../network/original";
export default {
  data() {
    return {
      leftInput: "",
      rightInput: "",
    };
  },
  methods: {
    // 点击时调用转化按钮
    changeClick() {
      change().then((res) => {
        console.log(res);
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin-top: 40px;
}
/* 布局 */
.layout {
  display: flex;
}
/* 文本域 */
.left-can {
  width: 45%;
}
.right-can {
  width: 45%;
}
::v-deep .el-textarea__inner {
  height: 800px;
}
/* 按钮 */
.changeBtn {
  margin: 0px 20px;
  display: flex;
  align-items: center;
}
</style>